import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Image from '@loggi/ui/components/image';
import View from '@loggi/ui/components/view';
import PropTypes from 'prop-types';
import React from 'react';
import Card from '../card/card.component';
import styles from './alert.component.scss';

export default function Alert(props) {
  const {
    illustration,
    illustrationClassName,
    illustrationShape,
    buttonsProps,
    children
  } = props;

  function renderImage() {
    if (!illustration) {
      return null;
    }
    return (
      <View className={illustrationClassName}>
        <Image src={illustration} noBackgroundColor shape={illustrationShape} />
      </View>
    );
  }

  function renderButtons() {
    if (!buttonsProps) {
      return null;
    }
    return buttonsProps.map((btnProps, index) => {
      let { btnId } = btnProps;
      btnId = index;
      return <Button key={btnId} {...btnProps} />;
    });
  }

  return (
    <Col className={styles.modal}>
      <Card
        className={styles.modalContent}
        gutter={{
          top: 'normal',
          left: 'onehalf',
          right: 'onehalf',
          bottom: 'normal'
        }}
      >
        {renderImage()}
        {children}
        {renderButtons()}
      </Card>
    </Col>
  );
}

Alert.displayName = 'Alert';

Alert.propTypes = {
  illustrationClassName: PropTypes.string,
  illustrationShape: PropTypes.string,
  illustration: PropTypes.node,
  buttonsProps: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node
};

Alert.defaultProps = {
  illustrationClassName: styles.illustration,
  illustrationShape: null,
  illustration: null,
  buttonsProps: null,
  children: null
};
